<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <orgsidebar></orgsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <!--<div class="moduleWrapper">
          <div class="moduleCard">
            <div v-show="hasReporting===true">
              <p>
                Your account has access to our Advanced Reporting Engine powered by Amazon Quicksight. To access: click the button below (you will be redirected to Amazon Quicksight)
              </p>
              <p>
                <button class="btn btn-primary" @click="accessQuicksight">Access Amazon Quicksight</button>
              </p>
              <form id="repEng" method="post" action="https://signin.aws.amazon.com/saml" style="display:none">
                <input type="hidden" id="RelayState" name="RelayState" value="https://quicksight.aws.amazon.com">
                <input type="hidden" id="SAMLResponse" name="SAMLResponse" value="">
              </form>
            </div>
            <div v-show="hasReporting!==true">
              <p>
                Your account does not have access to our Advanced Reporting Engine powered by Amazon Quicksight. To gain access, please contact SIMmersion and inquire about a Pro Account
              </p>
              <p>
                Standard reports are available by clicking the Reporting tab within each License Pool
              </p>
            </div>
          </div>
        </div>-->
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import orgsidebar from "../../layout/Organization/Sidebar.vue"

  export default {
    name: 'OrgReporting',
    components:{acheader,acfooter,orgsidebar},
    data() {
      return {
         hasReporting:false
      }
    },
    methods: {
      accessQuicksight() {
        this.apiCommand([
        {
          Operation: "Organization",
          Function: "AccessReportingEngine",
          Fields: {}
        }
        ]).then(response=>{
          var cr = JSON.parse(response.CommandResult);
          var mess = cr.returnObjects[0].returnObject;

          if (mess === "Failure") {
             this.popDialog(1, "You do not have access to the reporting engine. If you believe this is an error, please contact SIMmersion support.");
          }
          else {
            document.getElementById("SAMLResponse").value=mess;

            document.getElementById("repEng").submit();
          }

        });
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapOrg(this.$route.params.id);
        this.hasReporting=this.sdata.hasreporting;
      });
    }
  }
</script>
